'use strict';

var React = require('react');
var clsx = require('clsx');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".stepper-module_stepper-wrapper__1Jyyy {\n  box-sizing: border-box;\n  display: flex;\n  list-style: none;\n  margin: 0px auto;\n  padding: 5px;\n  width: 100%;\n}\n\n.stepper-module_stepper-wrapper__1Jyyy.stepper-module_vertical__3kx12 {\n  flex-direction: column;\n}\n\n.stepper-module_progress-step__1wSHh {\n  -webkit-box-flex: 1;\n  box-sizing: border-box;\n  display: block;\n  flex: 1 1 0%;\n  line-height: 12px;\n  margin: 0;\n  min-height: 20px;\n  min-width: 28px;\n  padding: 0;\n  position: relative;\n  text-align: center;\n}\n.stepper-module_progress-step__1wSHh::after {\n  content: \"\";\n  border-top: 1px dashed;\n  border-color: #d63426;\n  box-sizing: border-box;\n  display: block;\n  height: 0px;\n  right: 0%;\n  position: absolute;\n  top: 11px;\n  width: 99%;\n}\n.stepper-module_progress-step__1wSHh:first-child::after {\n  width: 50%;\n}\n.stepper-module_progress-step__1wSHh:last-child::after {\n  right: 50%;\n  width: 50%;\n}\n.stepper-module_progress-step__1wSHh.stepper-module_passed__2sYP8::after {\n  right: 50%;\n  width: 100%;\n}\n.stepper-module_progress-step__1wSHh.stepper-module_passed__2sYP8:first-child::after {\n  display: none;\n}\n.stepper-module_progress-step__1wSHh.stepper-module_passed__2sYP8:last-child::after {\n  right: 50%;\n  width: 100%;\n}\n.stepper-module_progress-step__1wSHh.stepper-module_next-active__8zpyI::after {\n  right: 1%;\n  width: 150%;\n}\n.stepper-module_progress-step__1wSHh.stepper-module_next-active__8zpyI:last-child::after {\n  right: 50%;\n  width: 100%;\n}\n\n.stepper-module_progress-step__1wSHh.stepper-module_vertical__3kx12 {\n  min-height: 65px;\n  flex: 1 1 auto;\n  text-align: inherit;\n}\n.stepper-module_progress-step__1wSHh.stepper-module_vertical__3kx12::after {\n  height: 100%;\n  left: 10px;\n  right: auto;\n  bottom: 0%;\n  top: inherit;\n  width: 0px !important;\n}\n.stepper-module_progress-step__1wSHh.stepper-module_vertical__3kx12:last-child::after {\n  bottom: 50%;\n  height: 50%;\n}\n.stepper-module_progress-step__1wSHh.stepper-module_vertical__3kx12.stepper-module_passed__2sYP8::after {\n  bottom: 50%;\n  height: 100%;\n}\n.stepper-module_progress-step__1wSHh.stepper-module_vertical__3kx12.stepper-module_passed__2sYP8:last-child::after {\n  bottom: 50%;\n  height: 100%;\n}\n.stepper-module_progress-step__1wSHh.stepper-module_vertical__3kx12.stepper-module_next-active__8zpyI::after {\n  bottom: 1%;\n  height: 150%;\n}\n.stepper-module_progress-step__1wSHh.stepper-module_vertical__3kx12.stepper-module_next-active__8zpyI:last-child::after {\n  bottom: 50%;\n  height: 100%;\n}\n\n.stepper-module_not-passed__3luS7 {\n  opacity: 0.3;\n}\n\n.stepper-module_current-or-passed__3hwq0 {\n  opacity: 1;\n}\n\n.stepper-module_circle__3IOoN {\n  align-items: center;\n  background-color: #fff;\n  border-radius: 50%;\n  box-shadow: 0 0 0 10px #fff;\n  box-sizing: border-box;\n  display: flex;\n  height: 22px;\n  justify-content: center;\n  margin: 0 auto;\n  position: relative;\n  transition: all 0.3s;\n  width: 22px;\n  z-index: 20;\n}\n\n.stepper-module_circle__3IOoN.stepper-module_vertical__3kx12 {\n  left: 0px;\n  margin: 0;\n  position: absolute;\n  top: 10px;\n}\n\n.stepper-module_label__2yYDC {\n  box-sizing: border-box;\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  height: 100%;\n  line-height: 20px;\n  padding: 14px 9.3px;\n}\n\n.stepper-module_label__2yYDC.stepper-module_vertical__3kx12 {\n  height: initial;\n  line-height: initial;\n  padding: 13px 0px 10px 40px;\n}";
var styles = {"stepper-wrapper":"stepper-module_stepper-wrapper__1Jyyy","vertical":"stepper-module_vertical__3kx12","progress-step":"stepper-module_progress-step__1wSHh","passed":"stepper-module_passed__2sYP8","next-active":"stepper-module_next-active__8zpyI","not-passed":"stepper-module_not-passed__3luS7","current-or-passed":"stepper-module_current-or-passed__3hwq0","circle":"stepper-module_circle__3IOoN","label":"stepper-module_label__2yYDC"};
styleInject(css_248z,{"insertAt":"top"});

const Step = ({ activeStep, currentOrPassed, handleKeyDown, step, index, selectIndex, theNextActive, vertical }) => {
    const { color = '#d63426', icon, label, ariaLabel, className } = step;
    const verticalClass = vertical && styles.vertical;
    const currentOrPassedClass = currentOrPassed ? styles.passed : styles['not-passed'];
    const activeStepClass = theNextActive && styles['next-active'];
    /* Custom ADA label with fallback to step-1. If ariaLabel is defined but empty, do not include the attribute. */
    const formattedAriaLabel = ariaLabel === '' ? undefined : (ariaLabel || "step-" + (index + 1));
    return (React__default['default'].createElement("li", { className: clsx__default['default'](styles['progress-step'], verticalClass, currentOrPassedClass, activeStepClass, className), tabIndex: selectIndex ? 0 : -1 },
        React__default['default'].createElement("div", { onClick: selectIndex ? () => selectIndex(index) : undefined, onKeyDown: (e) => handleKeyDown(e, index), role: "button", "aria-label": formattedAriaLabel, className: clsx__default['default'](styles.circle, verticalClass), itemID: "step-" + index, style: activeStep
                ? { border: `2px solid ${color}` }
                : { border: `2px solid ${color}`, cursor: selectIndex ? 'pointer' : '' } }, icon),
        label && React__default['default'].createElement("div", { className: clsx__default['default'](styles.label, verticalClass) }, label)));
};
var Step$1 = React.memo(Step);

const Stepper = (_a) => {
    var { activeStep, disabled = false, className, steps, selectIndex, vertical = false } = _a, rest = __rest(_a, ["activeStep", "disabled", "className", "steps", "selectIndex", "vertical"]);
    const handleKeyDown = (e, index) => {
        if (selectIndex) {
            switch (e.key) {
                case 'Enter':
                    selectIndex(index);
                    break;
                case 'ArrowLeft': {
                    const newIndex = activeStep - 1;
                    if (newIndex >= 0) {
                        selectIndex(newIndex);
                    }
                    break;
                }
                case 'ArrowRight': {
                    const newIndex = activeStep + 1;
                    if (newIndex < steps.length) {
                        selectIndex(newIndex);
                    }
                    break;
                }
            }
        }
    };
    return (React__default['default'].createElement("ul", Object.assign({ className: clsx__default['default'](styles['stepper-wrapper'], vertical && styles.vertical, className) }, rest), steps.map((step, index) => {
        const currentOrPassed = !disabled && activeStep >= index;
        const theNextActive = !disabled && activeStep + 1 === index;
        return (React__default['default'].createElement(Step$1, { key: index, activeStep: !disabled && activeStep === index, currentOrPassed: currentOrPassed, handleKeyDown: handleKeyDown, index: index, selectIndex: selectIndex, step: step, theNextActive: theNextActive, vertical: vertical }));
    })));
};

module.exports = Stepper;
